export default "__VITE_ASSET__B0OuE6e7__"